var map = {
	"./analogy-metaphor.md": [
		8960,
		817
	],
	"./concrete-examples.md": [
		6878,
		878
	],
	"./dual-coding.md": [
		9488,
		488
	],
	"./interleaving.md": [
		3021,
		21
	],
	"./spacing.md": [
		7930,
		930
	],
	"./variation.md": [
		6662,
		662
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 669;
module.exports = webpackAsyncContext;